import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { StaticImage } from "gatsby-plugin-image";

const WhatIsZmt = ({ lang }) => {
  const { t } = useTranslation();

  const renderImage = (lang) => {
    switch (lang) {
      case "th":
        return (
          <StaticImage
            src={`../../../assets/images/what-is-zmt-bg-laptop-th.png`}
            alt="What is ZMT"
            placeholder="blurred"
          />
        );
      case "id":
        return (
          <StaticImage
            src={`../../../assets/images/what-is-zmt-bg-laptop-id.png`}
            alt="What is ZMT"
            placeholder="blurred"
          />
        );
      case "au":
        return (
          <StaticImage
            src={`../../../assets/images/what-is-zmt-bg-laptop-au.png`}
            alt="What is ZMT"
            placeholder="blurred"
          />
        );
      default:
        return (
          <StaticImage
            src={`../../../assets/images/what-is-zmt-bg-laptop-global.png`}
            alt="What is ZMT"
            placeholder="blurred"
          />
        );
    }
  };

  return (
    <>
      <div id="what-is-zmt">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 box">
              <div className="text-center">
                <div
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="100"
                >
                  <h2>{t("zmt.whatIsZMT.title")}</h2>
                </div>
                <div
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="200"
                >
                  <p>
                    <Trans
                      i18nKey="zmt.whatIsZMT.description"
                      components={[
                        <span>ZMT</span>,
                        <br className="desktop" />,
                      ]}
                    />
                  </p>
                </div>
                {lang === "th" && (
                  <div
                    data-sal="slide-up"
                    data-sal-duration="500"
                    data-sal-easing="ease-out-cubic"
                    data-sal-delay="250"
                  >
                    <a
                      href={t("zmt.whatIsZMT.hrefCoinInsight")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans
                        i18nKey="zmt.whatIsZMT.coinInsight"
                        components={[]}
                      />
                    </a>
                  </div>
                )}
                <div
                  className="my-5"
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-easing="ease-out-cubic"
                  data-sal-delay="300"
                >
                  <a
                    className="button button-primary button-rounded"
                    href={t("zmt.whatIsZMT.hrefWhitePaper")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("zmt.whatIsZMT.btnDownloadWhitePaper")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="what-is-zmt-img"
          data-sal="slide-up"
          data-sal-duration="400"
          data-sal-easing="ease-in-quad"
        >
          {renderImage(lang)}
        </div>
      </div>
    </>
  );
};

export default WhatIsZmt;
